import { FC } from 'react';

import { Banner, Button, Text, useBreakpoint } from '@hh.ru/magritte-ui';

interface FormAdviceProps {
    message: string;
    actionLabel: string;
    onActionClick: () => void;
    actionDataQa?: string;
}

export const FormAdvice: FC<FormAdviceProps> = ({ message, actionLabel, onActionClick, actionDataQa }) => {
    const { isMobile } = useBreakpoint();

    return (
        <Banner
            showClose={false}
            style="warning-secondary"
            content={<Text typography="paragraph-2-regular">{message}</Text>}
            buttonBase={
                <Button
                    mode="primary"
                    size="small"
                    style="neutral"
                    onClick={onActionClick}
                    data-qa={actionDataQa}
                    stretched={isMobile}
                >
                    {actionLabel}
                </Button>
            }
        />
    );
};
